// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2hzOx","title":"Info_title__2oPAM","links":"Info_links__2BDmc","link":"Info_link__4j5uU","logo":"Info_logo__1-vNb"};